import { render, staticRenderFns } from "./AddressSearch.vue?vue&type=template&id=07c5f5c8&scoped=true&"
import script from "./AddressSearch.vue?vue&type=script&lang=js&"
export * from "./AddressSearch.vue?vue&type=script&lang=js&"
import style0 from "./AddressSearch.vue?vue&type=style&index=0&id=07c5f5c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c5f5c8",
  null
  
)

export default component.exports